/*
  Swiper for card rows that are a grid on desktop and a swipeable row below a breakpoint.

  Points that cost time elsewhere and are handled deliberately:

  - Swiper is loaded with `defer`, so it may not have parsed when this runs. Rather than
    assume an order this waits for the global and gives up after a bounded number of tries -
    without it the row still scrolls natively, so an endless poll would buy nothing.

  - The theme editor replaces a section's markup wholesale on every settings change, which
    leaves the previous instance bound to a detached node. Each init destroys whatever is
    already attached to the element, and the section re-initialises on shopify:section:load.

  - Above the breakpoint Swiper is switched off rather than reconfigured. A disabled Swiper
    clears its own transform, and the stylesheet then lays the slides out as a plain grid.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-oralux-slider]';

  function initOne(root) {
    if (!root) return;

    /* A stale instance from a previous render would keep listening on a detached node. */
    if (root.swiper) root.swiper.destroy(true, true);

    var slides = root.querySelectorAll('.swiper-slide').length;
    if (slides === 0) return;

    var space = parseInt(root.getAttribute('data-space'), 10) || 0;
    var spaceUp = parseInt(root.getAttribute('data-space-desktop'), 10) || space;
    var breakpoint = parseInt(root.getAttribute('data-breakpoint'), 10) || 750;

    var options = {
      slidesPerView: 'auto',
      spaceBetween: space,
      a11y: { enabled: true },
      /* Free scrolling, not paged: the design shows the next card peeking rather than
         snapping one card at a time. */
      freeMode: { enabled: true, sticky: false },
      breakpoints: {},
    };

    options.breakpoints[breakpoint] = { enabled: false, spaceBetween: spaceUp };

    new window.Swiper(root, options);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(initOne);
  }

  function whenSwiperReady(run) {
    if (window.Swiper) {
      run();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper) {
        clearInterval(timer);
        run();
      } else if (++tries >= 60) {
        clearInterval(timer);
      }
    }, 50);
  }

  whenSwiperReady(function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    whenSwiperReady(function () {
      initAll(event.target);
    });
  });
})();
